import React from 'react';
import './AboutUs.css';
import SEO from '../components/SEO';

function AboutUs() {
  return (
    <div className="about-page">
      <SEO 
        title="About Us - Trusted Newspaper Ad Agency"
        description="Learn about BookMyNewsAd, India's most trusted newspaper ad booking platform. We have served over 50,000 happy customers with lowest ad rates."
        url="/about"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'About Us', url: '/about' }
        ]}
      />
      <section className="about-hero">
        <div className="container">
          <h1>About BookMyNewsAd</h1>
          <p className="lead">Your trusted partner for newspaper advertising since 1998</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2>Who We Are</h2>
              <p>
                BookMyNewsAd is India's leading online platform for booking newspaper advertisements. 
                We've revolutionized the way people book ads by making it simple, affordable, and accessible to everyone.
              </p>
              <p>
                Our mission is to provide the most cost-effective and hassle-free newspaper advertising 
                solutions to individuals and businesses across India. With partnerships with over 500+ 
                newspapers, we ensure your message reaches the right audience.
              </p>
            </div>
            
            <div className="about-stats">
              <div className="stat-card">
                <h3>1,00,000+</h3>
                <p>Ads Booked</p>
              </div>
              <div className="stat-card">
                <h3>500+</h3>
                <p>Newspapers</p>
              </div>
              <div className="stat-card">
                <h3>100%</h3>
                <p>Customer Satisfaction</p>
              </div>
              <div className="stat-card">
                <h3>24/7</h3>
                <p>Support Available</p>
              </div>
            </div>
          </div>

          <div className="mission-vision">
            <div className="mission">
              <h2>Our Mission</h2>
              <p>
                To democratize newspaper advertising by making it accessible, affordable, and easy 
                for everyone. We believe in transparent pricing and exceptional customer service.
              </p>
            </div>
            
            <div className="vision">
              <h2>Our Vision</h2>
              <p>
                To become India's most trusted and preferred platform for all newspaper advertising 
                needs, setting new standards in service quality and customer satisfaction.
              </p>
            </div>
          </div>

          <div className="why-trust">
            <h2>Why Trust Us?</h2>
            <ul>
              <li>✓ Authorized ad booking partner with major newspapers</li>
              <li>✓ Transparent pricing with no hidden charges</li>
              <li>✓ Secure payment gateway</li>
              <li>✓ Expert assistance at every step</li>
              <li>✓ Quick turnaround time</li>
              <li>✓ Post-publication support</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
